import script from "./TransitionConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransitionConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./TransitionConfirmation.vue?vue&type=style&index=0&id=34d5e75a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d5e75a"]])

export default __exports__